package er.prateek.crossly.ui.screens.legal

actual fun currentPrivacyPolicyUrl(): String = PrivacyPolicyUrls.WEB
